<template>
  <el-select
    size="small"
    :multiple="multiple"
    :placeholder="placeholder"
    v-model="value"
    :remote="remote"
    :filterable="filterable"
    :collapse-tags="collapseTags"
    :collapse-tags-tooltip="collapseTagsTooltip"
    :remote-method="onSearch"
    @visible-change="onVisibleChange"
    :reserve-keyword="true"
    :allow-create="allowcreate"
    :default-first-option="defaultfirstoption"
  >
    <el-option
      v-for="itm of dataList"
      :key="itm.id"
      :label="itm.name"
      :value="itm.id"
    ></el-option>
    <el-pagination
      small
      layout="prev, pager, next"
      :page-size="pageSize"
      :pager-count="5"
      :total="totalCount"
      :current-page="page.pageindex"
      @current-change="handleCurrentChange"
      style="display: flex;
    align-items: end;
    justify-content: center;"
    />
  </el-select>
</template>

<script>
import { post } from "@/util/request";
export default {
  name: "SelectorWithLoadMore",
  props: {
    value: {
      type: [Array, String, Object],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请输入内容",
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    // 网络请求url
    url: { type: String, default: "" },
    // Select 组件是否可筛选
    filterable: {
      type: Boolean,
      default: false,
    },
    // 多选时是否将选中值按文字的形式展示
    collapseTags: {
      type: Boolean,
      default: false,
    },
    // 当鼠标悬停于折叠标签的文本时，是否显示所有选中的标签。 要使用此属性，collapse-tags属性必须设定为 true
    collapseTagsTooltip: {
      type: Boolean,
      default: false,
    },
    //其中的选项是否从服务器远程加载
    remote: {
      type: Boolean,
      default: false,
    },
    /**
     * name 显示名称
     * key value 选项值
     */
    formater: {
      type: Function,
      default: (data) => data,
    },
    ids: {
      type: [Array, Number],
      default: () => [],
    },
    allowcreate: {
      type: Boolean,
      default: false,
    },
    defaultfirstoption: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    queryModel: {
      type: Object,
      default: {}
    }
  },
  watch: {
    ids: {
      handler: function (val) {
        if (val) {
          if(typeof val === "string") {
            return;
          }
          let ids = typeof val === "number" ? [val] : val;
          this.page.queryModel.ids = ids;
          this.queryList();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataList: [],
      totalCount: 0,
      page: {
        pageindex: 1,
        // pageSize: 20,
        queryModel: {
          name: "",
        },
      },
    };
  },
  // 父组件没有传递ids才调用queryList函数,防止重复调用
  async mounted() {
    if (!this.ids || this.ids.length > 0) {
      await this.queryList();
    }
  },
  methods: {
    onSearch(val) {
      this.resetPage();
      this.page.queryModel.name = val;
      this.queryList();
    },
    resetPage() {
      this.page.pageindex = 1;
      this.page.queryModel.ids = [];
      this.page.queryModel.name = "";
    },
    handleCurrentChange(val) {
      this.page.pageindex = val;
      this.queryList();
    },
    // 下拉框隐藏/显示时需初始化列表，不然再次下拉出现的是上次的数据
    onVisibleChange() {
      this.resetPage();
      this.queryList();
    },
    async queryList() {
      this.page.pageSize = this.pageSize;
      this.page.queryModel = {
        ...this.page.queryModel,
        ...this.queryModel
      }
      let { entities = [], totalCount } = await post(this.url, this.page, {});
      this.totalCount = totalCount;
      this.dataList = this.formater(entities);
    },
  },
};
</script>
